<template>
    <div class="container boss-contanier">
        <div class="search_box" v-show="isShowSearchBox">
            <img
                src="../images/delete_icon.png"
                class="close_search_box"
                @click="isShowSearchBox = false"
            />
            <div class="search_main">
                <span></span>
                <input
                    type="text"
                    v-model="keyword"
                    placeholder="在此输入关键词语"
                    v-if="languageTypeVal == 1"
                />
                <input
                    type="text"
                    v-model="keyword"
                    placeholder="Please type in keywords here"
                    v-if="languageTypeVal == 2"
                />
                <input
                    type="text"
                    v-model="keyword"
                    placeholder="འདིར་གནད་ཚིག་འཇུག་རོགས་གནང་།"
                    v-if="languageTypeVal == 3"
                />
                <input
                    type="button"
                    value="འཚོལ་བཤེར།"
                    @click="search('zangs', 'འདིར་གནད་ཚིག་འཇུག་རོགས་གནང་།')"
                    v-if="languageTypeVal == 3"
                />
                <input
                    type="button"
                    value="搜索"
                    @click="search('zh-CN', '在此输入关键词语')"
                    v-if="languageTypeVal == 1"
                />
                <input
                    type="button"
                    value="Search"
                    @click="search('en-US', 'Please type in keywords here')"
                    v-if="languageTypeVal == 2"
                />
            </div>
        </div>
        <header v-show="languageTypeVal == 1">
            <div class="header_box">
                <div class="logo_box" @click="logoJump()">
                    <img style="height: 64px" src="../images/logo.png" />
                </div>
                <div class="header_right_box search-box2-wrap">
                    <div class="tools_box">
                        <span
                            @click="tabLanguage(3)"
                            :class="{ selected_lanuage: languageTypeVal == 3 }"
                            >བོད་སྐད།</span
                        >
                        <span
                            @click="tabLanguage(2)"
                            :class="{ selected_lanuage: languageTypeVal == 2 }"
                            >ENGLISH</span
                        >
                        <span
                            @click="tabLanguage(1)"
                            :class="{ selected_lanuage: languageTypeVal == 1 }"
                            >简体中文</span
                        >
                        <span
                            class="search"
                            @click="isShowSearchBox2 = !isShowSearchBox2"
                        ></span>
                        <el-dropdown v-if="$store.state.token">
                            <span
                                class="user"
                                :class="{ userActive: $store.state.token }"
                                @click="
                                    $store.state.token ||
                                        $router.push({ name: 'user' })
                                "
                            ></span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    @click.native="
                                        $router.push({ name: 'user' })
                                    "
                                    >个人中心</el-dropdown-item
                                >
                                <el-dropdown-item @click.native="userLogOut"
                                    >退出</el-dropdown-item
                                >
                            </el-dropdown-menu>
                        </el-dropdown>
                        <span
                            class="user"
                            v-else
                            :class="{ userActive: $store.state.token }"
                            @click="
                                $store.state.token ||
                                    $router.push({ name: 'user' })
                            "
                        ></span>
                    </div>
                    <div class="navs_box">
                        <ul>
                            <li
                                :class="{ selected_nav: navIndex == 0 }"
                                @click="tabNav(0, '/zh-CN/index?isNav=yes')"
                            >
                                首页
                            </li>
                            <li
                                :class="{
                                    selected_nav: navIndex == '票务预约'
                                }"
                                @mouseenter="branchNavIsHide = false"
                                @mouseleave="branchNavIsHide = true"
                            >
                                <p @click="tabNav()">票务预约</p>
                                <div
                                    class="branch_titles"
                                    style="width: 320px;text-align:center"
                                >
                                    <span
                                        @click="
                                            tabNav(
                                                '票务预约',
                                                $store.state[
                                                    !$store.state.isPersonal &&
                                                    $store.state.token
                                                        ? 'teamTicketJumpUrl'
                                                        : 'ticketJumpUrl'
                                                ]
                                            )
                                        "
                                        >门票预约</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                '票务预约',
                                                $store.state.cinemaJumpUrl,
                                                'person'
                                            )
                                        "
                                        >影院预约</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                '票务预约',
                                                $store.state.activityJumpUrl,
                                                'person'
                                            )
                                        "
                                        >活动预约</span
                                    >
                                </div>
                            </li>
                            <li
                                :class="{ selected_nav: navIndex == 1 }"
                                @mouseenter="branchNavIsHide = false"
                                @mouseleave="branchNavIsHide = true"
                            >
                                <p @click="tabNav(1, '/zh-CN/brief?isNav=yes')">
                                    博物馆概况
                                </p>
                                <div class="branch_titles" style="width: 320px">
                                    <span
                                        @click="
                                            tabNav(
                                                1,
                                                '/zh-CN/brief/historyRecord'
                                            )
                                        "
                                        >历史沿革</span
                                    >
                                    <span
                                        @click="
                                            tabNav(1, '/zh-CN/brief/sectionSet')
                                        "
                                        >机构设置</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                1,
                                                '/zh-CN/brief/curatorSpeech'
                                            )
                                        "
                                        >馆长致辞</span
                                    >
                                    <span
                                        @click="
                                            tabNav(1, '/zh-CN/brief/bigEvents')
                                        "
                                        >大事记</span
                                    >
                                </div>
                            </li>
                            <li
                                :class="{
                                    selected_nav: navIndex == '公众服务'
                                }"
                                @click="
                                    tabNav(
                                        '公众服务',
                                        '/zh-CN/publicService?isNav=yes'
                                    )
                                "
                            >
                                公众服务
                            </li>
                            <li
                                :class="{ selected_nav: navIndex == 2 }"
                                @click="
                                    tabNav(2, '/zh-CN/exhibitionMsg?isNav=yes')
                                "
                            >
                                展览展讯
                            </li>
                            <li
                                :class="{ selected_nav: navIndex == 3 }"
                                @mouseenter="branchNavIsHide = false"
                                @mouseleave="branchNavIsHide = true"
                            >
                                <p
                                    @click="
                                        tabNav(3, '/zh-CN/gemEnjoy?isNav=yes')
                                    "
                                >
                                    藏品鉴赏
                                </p>
                                <div class="branch_titles" style="width: 281px">
                                    <span
                                        @click="
                                            tabNav(3, '/zh-CN/gemEnjoy/enjoy')
                                        "
                                        >珍品赏析</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                3,
                                                '/zh-CN/gemEnjoy/quickLook'
                                            )
                                        "
                                        >文物快览</span
                                    >
                                    <span
                                        @click="
                                            tabNav(3, '/zh-CN/gemEnjoy/collect')
                                        "
                                        >文物征集与捐赠</span
                                    >
                                </div>
                            </li>
                            <li
                                :class="{ selected_nav: navIndex == 4 }"
                                @mouseenter="branchNavIsHide = false"
                                @mouseleave="branchNavIsHide = true"
                            >
                                <p
                                    @click="
                                        tabNav(
                                            4,
                                            '/zh-CN/wenChuangProduct/wcBoutique?isNav=yes'
                                        )
                                    "
                                >
                                    特色文创
                                </p>
                                <div class="branch_titles" style="width: 240px">
                                    <span
                                        @click="
                                            tabNav(
                                                4,
                                                '/zh-CN/wenchuangProduct/wcBoutique'
                                            )
                                        "
                                        >文创精品</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                4,
                                                '/zh-CN/wenchuangProduct/wcProducts'
                                            )
                                        "
                                        >文创产品</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                4,
                                                '/zh-CN/wenchuangProduct/wcDynamic'
                                            )
                                        "
                                        >文创动态</span
                                    >
                                </div>
                            </li>
                            <li
                                :class="{ selected_nav: navIndex == 5 }"
                                @mouseenter="branchNavIsHide = false"
                                @mouseleave="branchNavIsHide = true"
                            >
                                <p
                                    @click="
                                        tabNav(
                                            5,
                                            '/zh-CN/educationActivity?isNav=yes'
                                        )
                                    "
                                >
                                    教育活动
                                </p>
                                <div class="branch_titles" style="width: 160px">
                                    <span
                                        @click="
                                            tabNav(
                                                5,
                                                '/zh-CN/educationActivity?isNav=yes'
                                            )
                                        "
                                        >教育活动</span
                                    >
                                    <span @click="tabNav(5, '/zh-CN/yanxue')"
                                        >研学教育</span
                                    >
                                </div>
                            </li>
                            <!-- <li
                :class="{ selected_nav: navIndex == 6 }"
                @mouseenter="branchNavIsHide = false"
                @mouseleave="branchNavIsHide = true"
              >
                <p
                  @click="
                    tabNav(6, '/zh-CN/academicResearch/academicQikan?isNav=yes')
                  "
                >
                  学术研究
                </p>
                <div class="branch_titles" style="width: 180px">

                  <span
                    @click="tabNav(6, '/zh-CN/academicResearch/academicQikan')"
                    >学术期刊</span
                  >
                  <span
                    @click="
                      tabNav(6, '/zh-CN/academicResearch/academicClassroom')
                    "
                    >学术讲堂</span
                  >
                </div>
              </li> -->
                            <li
                                :class="{ selected_nav: navIndex == 7 }"
                                @mouseenter="branchNavIsHide = false"
                                @mouseleave="branchNavIsHide = true"
                            >
                                <p
                                    @click="
                                        tabNav(
                                            7,
                                            '/zh-CN/scienceProtect?isNav=yes'
                                        )
                                    "
                                >
                                    科技保护
                                </p>
                                <div
                                    class="branch_titles_right"
                                    style="width: 310px; text-align:center;left: 50%;transform: translateX(-50%)"
                                >
                                    <span
                                        @click="
                                            tabNav(
                                                7,
                                                '/zh-CN/scienceProtect/scienceIntro'
                                            )
                                        "
                                        >联合工作站简介</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                7,
                                                '/zh-CN/scienceProtect/scienceAchievement'
                                            )
                                        "
                                        >保护修复成果</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                7,
                                                '/zh-CN/scienceProtect/scienceKnowledge'
                                            )
                                        "
                                        >科普知识</span
                                    >
                                </div>
                            </li>
                            <li
                                :class="{
                                    selected_nav: navIndex == '博物馆之友'
                                }"
                                @mouseenter="branchNavIsHide = false"
                                @mouseleave="branchNavIsHide = true"
                            >
                                <p
                                    @click="
                                        tabNav(
                                            '博物馆之友',
                                            '/zh-CN/educationActivity/volunteerHome'
                                        )
                                    "
                                >
                                    博物馆之友
                                </p>
                                <div
                                    class="branch_titles branch_titles2"
                                    :style="{
                                        width: isOpen ? '290px' : '190px'
                                    }"
                                >
                                    <!-- <span
                    @click="
                      tabNav(
                        '博物馆之友',
                        '/zh-CN/educationActivity/volunteerHome'
                      )
                    "
                    >志愿者招募</span> -->
                                    <span
                                        @click="
                                            tabNav(
                                                '博物馆之友',
                                                $store.state.volunteerJumpUrl +
                                                    '/volunteer/list',
                                                'jump'
                                            )
                                        "
                                        >志愿者招募</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                '博物馆之友',
                                                $store.state.volunteerJumpUrl +
                                                    '/starVote/list',
                                                'jump'
                                            )
                                        "
                                        >志愿者风采</span
                                    >
                                    <span
                                        v-if="isOpen == 1"
                                        @click="
                                            tabNav(
                                                '博物馆会员',
                                                $store.state.memberJumpUrl,
                                                'jump'
                                            )
                                        "
                                        >博物馆会员</span
                                    >
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="s-box2-div" v-if="isShowSearchBox2">
                        <input
                            v-model="keyWord2"
                            placeholder="请在此搜索关键词..."
                            class="search-box2"
                            type="text"
                        />
                        <img
                            class="sousuo"
                            @click="search('zh-CN')"
                            src="../images/new/sousuo.png"
                        />
                    </div>
                </div>
            </div>
            <div class="branch_nav" :class="{ is_hide: branchNavIsHide }"></div>
        </header>
        <!--英藏版头部开始-->
        <header v-show="languageTypeVal == 2" class="us_header">
            <div class="header_box">
                <div class="logo_box" @click="logoJump()">
                    <img style="height: 64px" src="../images/logo.png" />
                </div>
                <div class="header_right_box search-box2-wrap">
                    <div class="tools_box">
                        <span
                            @click="tabLanguage(3)"
                            :class="{ selected_lanuage: languageTypeVal == 3 }"
                            >བོད་སྐད།</span
                        >
                        <span
                            @click="tabLanguage(2)"
                            :class="{ selected_lanuage: languageTypeVal == 2 }"
                            >ENGLISH</span
                        >
                        <span
                            @click="tabLanguage(1)"
                            :class="{ selected_lanuage: languageTypeVal == 1 }"
                            >简体中文</span
                        >
                        <span
                            class="search"
                            @click="isShowSearchBox2 = !isShowSearchBox2"
                        ></span>
                        <!-- <span
                            class="user"
                            :class="{ userActive: $store.state.token }"
                            @click="$router.push({ name: 'user' })"
                        ></span> -->
                    </div>
                    <div class="navs_box">
                        <ul>
                            <li
                                :class="{ selected_nav: navIndex == 0 }"
                                @click="tabNav(0, '/en-US/index?isNav=yes')"
                            >
                                Home
                            </li>
                            <li
                                :class="{ selected_nav: navIndex == 9 }"
                                @click="
                                    tabNavUC(
                                        '票务预约',
                                        $store.state[
                                            !$store.state.isPersonal &&
                                            $store.state.token
                                                ? 'teamTicketJumpUrl'
                                                : 'ticketJumpUrl'
                                        ]
                                    )
                                "
                            >
                                Tickets
                            </li>
                            <li
                                :class="{ selected_nav: navIndex == 1 }"
                                @mouseenter="branchNavIsHide = false"
                                @mouseleave="branchNavIsHide = true"
                            >
                                <p @click="tabNav(1, '/en-US/brief?isNav=yes')">
                                    Introduction
                                </p>
                                <div class="branch_titles" style="width: 667px">
                                    <span
                                        @click="
                                            tabNav(
                                                1,
                                                '/en-US/brief/historyRecord'
                                            )
                                        "
                                        >Historical Development</span
                                    >
                                    <span
                                        @click="
                                            tabNav(1, '/en-US/brief/sectionSet')
                                        "
                                        >Organization Structuring</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                1,
                                                '/en-US/brief/curatorSpeech'
                                            )
                                        "
                                        >Curator’s Words</span
                                    >
                                    <span
                                        @click="
                                            tabNav(1, '/en-US/brief/bigEvents')
                                        "
                                        >Chronicle of Events</span
                                    >
                                </div>
                            </li>
                            <li
                                :class="{ selected_nav: navIndex == 2 }"
                                @click="
                                    tabNav(2, '/en-US/exhibitionMsg?isNav=yes')
                                "
                            >
                                Exhibitions
                            </li>
                            <li
                                :class="{ selected_nav: navIndex == 3 }"
                                @mouseenter="branchNavIsHide = false"
                                @mouseleave="branchNavIsHide = true"
                            >
                                <p
                                    @click="
                                        tabNav(3, '/en-US/gemEnjoy?isNav=yes')
                                    "
                                >
                                    Objects
                                </p>
                                <div class="branch_titles" style="width: 690px">
                                    <span
                                        @click="
                                            tabNav(3, '/en-US/gemEnjoy/enjoy')
                                        "
                                        >Treasure Appreciation</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                3,
                                                '/en-US/gemEnjoy/quickLook'
                                            )
                                        "
                                        >Quick View of Cultural Relics</span
                                    >
                                    <span
                                        @click="
                                            tabNav(3, '/en-US/gemEnjoy/collect')
                                        "
                                        >Collection and Donation of Cultural
                                        Relics</span
                                    >
                                </div>
                            </li>
                            <li
                                :class="{ selected_nav: navIndex == 4 }"
                                @mouseenter="branchNavIsHide = false"
                                @mouseleave="branchNavIsHide = true"
                            >
                                <p
                                    @click="
                                        tabNav(
                                            4,
                                            '/en-US/wenChuangProduct/wcBoutique?isNav=yes'
                                        )
                                    "
                                >
                                    Souvenirs
                                </p>
                                <div class="branch_titles" style="width: 415px">
                                    <span
                                        @click="
                                            tabNav(
                                                4,
                                                '/en-US/wenchuangProduct/wcBoutique'
                                            )
                                        "
                                        >Exquisite Souvenirs</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                4,
                                                '/en-US/wenchuangProduct/wcProducts'
                                            )
                                        "
                                        >Souvenirs</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                4,
                                                '/en-US/wenchuangProduct/wcDynamic'
                                            )
                                        "
                                        >News about Souvenirs</span
                                    >
                                </div>
                            </li>
                            <li
                                @click="
                                    tabNav(
                                        5,
                                        '/en-US/educationActivity/activityList1?isNav=yes'
                                    )
                                "
                                :class="{ selected_nav: navIndex == 5 }"
                            >
                                Activities
                            </li>
                            <li
                                :class="{ selected_nav: navIndex == 6 }"
                                @mouseenter="branchNavIsHide = false"
                                @mouseleave="branchNavIsHide = true"
                            >
                                <p
                                    @click="
                                        tabNav(
                                            6,
                                            '/en-US/academicResearch?isNav=yes'
                                        )
                                    "
                                >
                                    Academics
                                </p>
                                <div class="branch_titles" style="width: 496px">
                                    <span
                                        @click="
                                            tabNav(
                                                6,
                                                '/en-US/academicResearch/academicJigou'
                                            )
                                        "
                                        >Academic Institutions</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                6,
                                                '/en-US/academicResearch/academicQikan'
                                            )
                                        "
                                        >Academic Periodicals</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                6,
                                                '/en-US/academicResearch/academicClassroom'
                                            )
                                        "
                                        >Academic Classroom</span
                                    >
                                </div>
                            </li>
                            <li
                                :class="{ selected_nav: navIndex == 7 }"
                                @mouseenter="branchNavIsHide = false"
                                @mouseleave="branchNavIsHide = true"
                            >
                                <p
                                    @click="
                                        tabNav(
                                            7,
                                            '/en-US/scienceProtect?isNav=yes'
                                        )
                                    "
                                >
                                    Protection
                                </p>
                                <div
                                    class="branch_titles_right"
                                    style="width: 841px"
                                >
                                    <span
                                        @click="
                                            tabNav(
                                                7,
                                                '/en-US/scienceProtect/scienceIntro'
                                            )
                                        "
                                        >Introduction to Contact
                                        Workstation</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                7,
                                                '/en-US/scienceProtect/scienceAchievement'
                                            )
                                        "
                                        >Achievements of Protection and
                                        Restoration</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                7,
                                                '/en-US/scienceProtect/scienceKnowledge'
                                            )
                                        "
                                        >Science Popularization Knowledge</span
                                    >
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="s-box2-div" v-if="isShowSearchBox2">
                        <input
                            v-model="keyWord2"
                            placeholder="search..."
                            class="search-box2"
                            type="text"
                        />
                        <img
                            class="sousuo"
                            @click="search('en-US')"
                            src="../images/new/sousuo.png"
                        />
                    </div>
                </div>
            </div>
            <div class="branch_nav" :class="{ is_hide: branchNavIsHide }"></div>
        </header>
        <!--英藏版头部结束-->
        <header v-show="languageTypeVal == 3" class="us_header">
            <div class="header_box">
                <div class="logo_box" @click="logoJump()">
                    <img style="height: 64px" src="../images/logo.png" />
                </div>
                <div class="header_right_box search-box2-wrap">
                    <div class="tools_box">
                        <span
                            @click="tabLanguage(3)"
                            :class="{ selected_lanuage: languageTypeVal == 3 }"
                            >བོད་སྐད།</span
                        >
                        <span
                            @click="tabLanguage(2)"
                            :class="{ selected_lanuage: languageTypeVal == 2 }"
                            >ENGLISH</span
                        >
                        <span
                            @click="tabLanguage(1)"
                            :class="{ selected_lanuage: languageTypeVal == 1 }"
                            >简体中文</span
                        >
                        <span
                            class="search"
                            @click="isShowSearchBox2 = !isShowSearchBox2"
                        ></span>
                        <span
                            class="user"
                            :class="{ userActive: $store.state.token }"
                            @click="$router.push({ name: 'user' })"
                        ></span>
                    </div>
                    <div class="navs_box">
                        <ul>
                            <li
                                :class="{ selected_nav: navIndex == 0 }"
                                @click="tabNav(0, '/zangs/index')"
                            >
                                མདུན་ངོས།
                            </li>
                            <li
                                :class="{ selected_nav: navIndex == 1 }"
                                @mouseenter="branchNavIsHide = false"
                                @mouseleave="branchNavIsHide = true"
                            >
                                <p @click="tabNav(1, '/zangs/brief')">
                                    གནས་ཚུལ་མདོར་བསྡུས།
                                </p>
                                <div class="branch_titles" style="width: 376px">
                                    <span
                                        @click="
                                            tabNav(
                                                1,
                                                '/zangs/brief/historyRecord'
                                            )
                                        "
                                        >ལོ་རྒྱུས་འཕེལ་རིམ།</span
                                    >
                                    <span
                                        @click="
                                            tabNav(1, '/zangs/brief/sectionSet')
                                        "
                                        >ལས་ཁུངས་བཀོད་སྒྲིག</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                1,
                                                '/zangs/brief/curatorSpeech'
                                            )
                                        "
                                        >མཛོད་ཁང་གི་འགོ་གཙོའི་ཞུ་ཚིག</span
                                    >
                                    <span
                                        @click="
                                            tabNav(1, '/zangs/brief/bigEvents')
                                        "
                                        >དོན་ཆེན་ཟིན་བཀོད།</span
                                    >
                                </div>
                            </li>
                            <li
                                :class="{ selected_nav: navIndex == 2 }"
                                @click="tabNav(2, '/zangs/exhibitionMsg')"
                            >
                                བཤམས་སྟོན་གྱི་བརྡ་འཕྲིན།
                            </li>
                            <li
                                :class="{ selected_nav: navIndex == 3 }"
                                @mouseenter="branchNavIsHide = false"
                                @mouseleave="branchNavIsHide = true"
                            >
                                <p @click="tabNav(3, '/zangs/gemEnjoy')">
                                    རྟེན་རྫས་མྱོང་རོལ།
                                </p>
                                <div class="branch_titles" style="width: 337px">
                                    <span
                                        @click="
                                            tabNav(3, '/zangs/gemEnjoy/enjoy')
                                        "
                                        >རྟེན་རྫས་རྩ་ཆེན་ཉམས་ཞིབ།</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                3,
                                                '/zangs/gemEnjoy/quickLook'
                                            )
                                        "
                                        >རིག་དངོས་མྱུར་གཟིགས།</span
                                    >
                                    <span
                                        @click="
                                            tabNav(3, '/zangs/gemEnjoy/collect')
                                        "
                                        >རིག་དངོས་བསྡུ་རུབ་དང་སྐྱེས་འབུལ།</span
                                    >
                                </div>
                            </li>
                            <li
                                :class="{ selected_nav: navIndex == 4 }"
                                @mouseenter="branchNavIsHide = false"
                                @mouseleave="branchNavIsHide = true"
                            >
                                <p
                                    @click="
                                        tabNav(
                                            4,
                                            '/zangs/wenChuangProduct/wcBoutique'
                                        )
                                    "
                                >
                                    རིག་གནས་གསར་གཏོད།
                                </p>
                                <div class="branch_titles" style="width: 302px">
                                    <span
                                        @click="
                                            tabNav(
                                                4,
                                                '/zangs/wenchuangProduct/wcBoutique'
                                            )
                                        "
                                        >རིག་གཏོད་སྤུས་ལེགས་ཐོན་རྫས།</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                4,
                                                '/zangs/wenchuangProduct/wcProducts'
                                            )
                                        "
                                        >རིག་གཏོད་ཐོན་རྫས།</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                4,
                                                '/zangs/wenchuangProduct/wcDynamic'
                                            )
                                        "
                                        >རིག་གཏོད་གནས་སྟངས།</span
                                    >
                                </div>
                            </li>
                            <li
                                @click="
                                    tabNav(
                                        5,
                                        '/zangs/educationActivity/activityList1?typeVal=1'
                                    )
                                "
                                :class="{ selected_nav: navIndex == 5 }"
                            >
                                སློབ་གསོའི་བྱེད་སྒོ།
                            </li>
                            <li
                                :class="{ selected_nav: navIndex == 6 }"
                                @mouseenter="branchNavIsHide = false"
                                @mouseleave="branchNavIsHide = true"
                            >
                                <p
                                    @click="
                                        tabNav(6, '/zangs/academicResearch')
                                    "
                                >
                                    རིག་གཞུང་ཞིབ་འཇུག
                                </p>
                                <div class="branch_titles" style="width: 254px">
                                    <span
                                        @click="
                                            tabNav(
                                                6,
                                                '/zangs/academicResearch/academicJigou'
                                            )
                                        "
                                        >རིག་གཞུང་སྡེ་ཁག</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                6,
                                                '/zangs/academicResearch/academicQikan'
                                            )
                                        "
                                        >རིག་གཞུང་དུས་དེབ།</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                6,
                                                '/zangs/academicResearch/academicClassroom'
                                            )
                                        "
                                        >རིག་གཞུང་ཁྲིད་སྟེགས།</span
                                    >
                                </div>
                            </li>
                            <li
                                :class="{ selected_nav: navIndex == 7 }"
                                @mouseenter="branchNavIsHide = false"
                                @mouseleave="branchNavIsHide = true"
                            >
                                <p @click="tabNav(7, '/zangs/scienceProtect')">
                                    ཚན་རྩལ་སྲུང་སྐྱོབ
                                </p>
                                <div
                                    class="branch_titles_right"
                                    style="width: 340px"
                                >
                                    <span
                                        @click="
                                            tabNav(
                                                7,
                                                '/zangs/scienceProtect/scienceIntro'
                                            )
                                        "
                                        >མཉམ་འབྲེལ་ལས་དོན་ས་ཚིགས།</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                7,
                                                '/zangs/scienceProtect/scienceAchievement'
                                            )
                                        "
                                        >སྲུང་སྐྱོབ་ཞིག་གསོའི་འབྲས་བུ།</span
                                    >
                                    <span
                                        @click="
                                            tabNav(
                                                7,
                                                '/zangs/scienceProtect/scienceKnowledge'
                                            )
                                        "
                                        >ཚན་རིག་ཁྱབ་གདལ་ཤེས་བྱ།</span
                                    >
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="s-box2-div" v-if="isShowSearchBox2">
                        <input
                            v-model="keyWord2"
                            placeholder="请在此搜索关键词..."
                            class="search-box2"
                            type="text"
                        />
                        <img
                            class="sousuo"
                            @click="search('zangs')"
                            src="../images/new/sousuo.png"
                        />
                    </div>
                </div>
            </div>
            <div class="branch_nav" :class="{ is_hide: branchNavIsHide }"></div>
        </header>
        <!--英藏版头部结束-->
        <div class="main" style="overflow: hidden">
            <router-view></router-view>
        </div>
        <footer>
            <div class="footer_box">
                <table border="0" v-show="languageTypeVal == 2">
                    <tr>
                        <th
                            @click="
                                tabNav(
                                    1,
                                    '/en-US/brief/historyRecord?isNav=yes'
                                )
                            "
                        >
                            Introduction
                        </th>
                        <th @click="tabNav(2, '/en-US/allZhuanti?isNav=yes')">
                            Exhibitions
                        </th>
                        <th
                            @click="
                                tabNav(3, '/en-US/gemEnjoy/enjoy?isNav=yes')
                            "
                        >
                            Objects
                        </th>
                        <th
                            @click="
                                tabNav(
                                    4,
                                    '/en-US/wenChuangProduct/wcBoutique?isNav=yes'
                                )
                            "
                        >
                            Souvenirs
                        </th>
                        <th
                            @click="
                                tabNav(
                                    5,
                                    '/en-US/educationActivity/volunteerHome?isNav=yes'
                                )
                            "
                        >
                            Activities
                        </th>
                        <th
                            @click="
                                tabNav(
                                    6,
                                    '/en-US/academicResearch/academicJigou?isNav=yes'
                                )
                            "
                        >
                            Academics
                        </th>
                        <th
                            @click="
                                tabNav(
                                    7,
                                    '/en-US/scienceProtect/scienceIntro?isNav=yes'
                                )
                            "
                        >
                            Protection
                        </th>
                    </tr>
                </table>

                <table border="0" v-show="languageTypeVal == 3">
                    <tr>
                        <th @click="tabNav(1, '/zangs/brief/historyRecord')">
                            <font v-if="languageTypeVal == 3"
                                >གནས་ཚུལ་མདོར་བསྡུས།</font
                            >
                        </th>
                        <th @click="tabNav(2, '/zangs/allZhuanti')">
                            <font v-if="languageTypeVal == 3"
                                >བཤམས་སྟོན་གྱི་བརྡ་འཕྲིན།</font
                            >
                        </th>
                        <th @click="tabNav(3, '/zangs/gemEnjoy/enjoy')">
                            <font v-if="languageTypeVal == 3"
                                >རྟེན་རྫས་མྱོང་རོལ།</font
                            >
                        </th>
                        <th
                            @click="
                                tabNav(4, '/zangs/wenChuangProduct/wcProducts')
                            "
                        >
                            <font v-if="languageTypeVal == 3"
                                >རིག་གནས་གསར་གཏོད།</font
                            >
                        </th>
                        <th
                            @click="
                                tabNav(
                                    5,
                                    '/zangs/educationActivity/volunteerHome'
                                )
                            "
                        >
                            <font v-if="languageTypeVal == 3"
                                >སློབ་གསོའི་བྱེད་སྒོ།</font
                            >
                        </th>
                        <th
                            @click="
                                tabNav(
                                    6,
                                    '/zangs/academicResearch/academicJigou'
                                )
                            "
                        >
                            <font v-if="languageTypeVal == 3"
                                >རིག་གཞུང་ཞིབ་འཇུག</font
                            >
                        </th>
                        <th
                            @click="
                                tabNav(7, '/zangs/scienceProtect/scienceIntro')
                            "
                        >
                            <font v-if="languageTypeVal == 3"
                                >ཚན་རྩལ་སྲུང་སྐྱོབ།</font
                            >
                        </th>
                    </tr>
                </table>

                <table border="0" v-show="languageTypeVal == 1">
                    <tr>
                        <!-- <th @click="tabNav('票务预约','/zh-CN/ticketBook')">票务预约</th> -->
                        <th
                            @click="
                                tabNav(
                                    1,
                                    '/zh-CN/brief/historyRecord?isNav=yes'
                                )
                            "
                        >
                            博物馆概况
                        </th>
                        <th
                            @click="
                                tabNav(
                                    '公众服务',
                                    '/zh-CN/publicService?isNav=yes'
                                )
                            "
                        >
                            公众服务
                        </th>
                        <th
                            @click="tabNav(2, '/zh-CN/exhibitionMsg?isNav=yes')"
                        >
                            展览展讯
                        </th>
                        <th
                            @click="
                                tabNav(3, '/zh-CN/gemEnjoy/enjoy?isNav=yes')
                            "
                        >
                            藏品鉴赏
                        </th>
                        <th
                            @click="
                                tabNav(
                                    4,
                                    '/zh-CN/wenChuangProduct/wcBoutique?isNav=yes'
                                )
                            "
                        >
                            特色文创
                        </th>
                        <th
                            @click="
                                tabNav(5, '/zh-CN/educationActivity?isNav=yes')
                            "
                        >
                            教育活动
                        </th>
                        <!-- <th
              @click="
                tabNav(6, '/zh-CN/academicResearch/academicJigou?isNav=yes')
              "
            >
              学术研究
            </th> -->
                        <th
                            @click="
                                tabNav(
                                    7,
                                    '/zh-CN/scienceProtect/scienceIntro?isNav=yes'
                                )
                            "
                        >
                            科技保护
                        </th>
                        <th
                            @click="
                                tabNav(
                                    '博物馆之友',
                                    '/zh-CN/educationActivity/volunteerHome?isNav=yes'
                                )
                            "
                        >
                            博物馆之友
                        </th>
                    </tr>
                    <tr>
                        <td @click="tabNav(1, '/zh-CN/brief/historyRecord')">
                            历史沿革
                        </td>
                        <td
                            @click="
                                tabNav(
                                    '公众服务',
                                    '/zh-CN/publicService?isNav=yes#openCloseTime'
                                )
                            "
                        >
                            开闭馆时间
                        </td>
                        <td
                            @click="
                                tabNav(
                                    2,
                                    '/zh-CN/exhibitionReview?exhibitionType=2&exhibitionName=常设展览'
                                )
                            "
                        >
                            常设展览
                        </td>

                        <td @click="tabNav(3, '/zh-CN/gemEnjoy/enjoy')">
                            珍品赏析
                        </td>
                        <td
                            @click="
                                tabNav(4, '/zh-CN/wenchuangProduct/wcBoutique')
                            "
                        >
                            文创精品
                        </td>
                        <td
                            @click="
                                tabNav(
                                    5,
                                    '/zh-CN/educationActivity/activityList1?activityType=最新活动&typeVal=1&navIndex=5'
                                )
                            "
                        >
                            最新活动
                        </td>
                        <!-- <td @click="tabNav(6,'/zh-CN/academicResearch/academicJigou')">学术机构</td> -->
                        <!-- <td @click="tabNav(6, '/zh-CN/academicResearch/academicQikan')">
              学术期刊
            </td> -->
                        <td
                            @click="
                                tabNav(7, '/zh-CN/scienceProtect/scienceIntro')
                            "
                        >
                            联合工作站简介
                        </td>
                        <td
                            @click="
                                tabNav(
                                    '博物馆之友',
                                    $store.state.volunteerJumpUrl,
                                    'jump'
                                )
                            "
                        >
                            志愿者招募
                        </td>
                    </tr>
                    <tr>
                        <td @click="tabNav(1, '/zh-CN/brief/sectionSet')">
                            机构设置
                        </td>
                        <td
                            @click="
                                tabNav(
                                    '公众服务',
                                    '/zh-CN/publicService?isNav=yes#trafficRoad'
                                )
                            "
                        >
                            交通路线
                        </td>
                        <td
                            @click="
                                tabNav(
                                    2,
                                    '/zh-CN/allZhuanti?exhibitionType=1&exhibitionName=专题展览'
                                )
                            "
                        >
                            专题展览
                        </td>

                        <td @click="tabNav(3, '/zh-CN/gemEnjoy/quickLook')">
                            文物快览
                        </td>
                        <td
                            @click="
                                tabNav(4, '/zh-CN/wenchuangProduct/wcProducts')
                            "
                        >
                            文创产品
                        </td>
                        <td
                            @click="
                                tabNav(
                                    5,
                                    '/zh-CN/educationActivity/activityList2?typeVal=2&navIndex=5'
                                )
                            "
                        >
                            专题活动
                        </td>
                        <!-- <td @click="tabNav(6, '/zh-CN/academicResearch/academicClassroom')">
              学术讲堂
            </td> -->
                        <td
                            @click="
                                tabNav(
                                    7,
                                    '/zh-CN/scienceProtect/scienceAchievement'
                                )
                            "
                        >
                            保护修复成果
                        </td>
                        <td
                            @click="
                                tabNav(
                                    '博物馆之友',
                                    '/zh-CN/educationActivity/volunteerHome'
                                )
                            "
                        >
                            志愿者风采
                        </td>
                    </tr>
                    <tr>
                        <td @click="tabNav(1, '/zh-CN/brief/curatorSpeech')">
                            馆长致辞
                        </td>
                        <td
                            @click="
                                tabNav(
                                    '公众服务',
                                    '/zh-CN/publicService?isNav=yes#visitKnow'
                                )
                            "
                        >
                            参观须知
                        </td>
                        <td
                            @click="
                                tabNav(
                                    2,
                                    '/zh-CN/allZhuanti?exhibitionType=2&exhibitionName=特展回眸'
                                )
                            "
                        >
                            特展回眸
                        </td>

                        <td @click="tabNav(3, '/zh-CN/gemEnjoy/collect')">
                            文物征集与捐赠
                        </td>
                        <td
                            @click="
                                tabNav(4, '/zh-CN/wenchuangProduct/wcDynamic')
                            "
                        >
                            文创动态
                        </td>
                        <td
                            @click="
                                tabNav(
                                    5,
                                    '/zh-CN/educationActivity/activityList3?typeVal=4&navIndex=5'
                                )
                            "
                        >
                            活动回顾
                        </td>

                        <td
                            @click="
                                tabNav(
                                    7,
                                    '/zh-CN/scienceProtect/scienceKnowledge'
                                )
                            "
                        >
                            科普知识
                        </td>
                        <td
                            v-if="isOpen == 1"
                            @click="
                                tabNav(
                                    '博物馆会员',
                                    $store.state.memberJumpUrl,
                                    'jump'
                                )
                            "
                        >
                            博物馆会员
                        </td>
                    </tr>
                    <tr>
                        <td @click="tabNav(1, '/zh-CN/brief/bigEvents')">
                            大事记
                        </td>
                        <td></td>
                        <td
                            @click="
                                tabNav(
                                    2,
                                    '/zh-CN/allQuanjing?exhibitionType=3&exhibitionName=全景漫游'
                                )
                            "
                        >
                            全景漫游
                        </td>
                        <td></td>
                        <td></td>
                        <td
                            @click="
                                tabNav(
                                    5,
                                    '/zh-CN/educationActivity/activityList4?activityType=少儿专区&typeVal=3'
                                )
                            "
                        >
                            少儿专区
                        </td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td @click="tabNav(1, '/zh-CN/ticket/extensionPro')">
                            改扩建工程
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>

                        <td></td>
                        <td></td>
                    </tr>
                </table>

                <div
                    class="museum_info"
                    style="position: absolute; left: 0; top: 50px"
                    v-show="languageTypeVal == 2 || languageTypeVal == 3"
                >
                    <p style="font-size: 14px">
                        <font v-if="languageTypeVal == 2">Address:</font>
                        <font v-if="languageTypeVal == 3"
                            >རྟེན་རྫས་བཤམས་མཛོད་ཁང་གི་ས་གནས། :</font
                        >
                    </p>
                    <p style="font-size: 12px; margin: 8px 0">
                        <font v-if="languageTypeVal == 3" color="#ccc"
                            >ས་གནས།
                            བོད་རང་སྐྱོང་ལྗོངས་ལྷ་ས་གྲོང་ཁྱེར་ཁྲེང་ཀོན་ཆུས་མི་རིགས་ལྷོ་ལམ་ཨང་རྟགས་2པ།</font
                        >
                        <font v-if="languageTypeVal == 2" color="#ccc"
                            >No.2 on the Minzu South Road, Chengguan District,
                            Lhasa, Tibet Autonomous Region</font
                        >
                    </p>
                    <p style="font-size: 14px" v-if="languageTypeVal == 2">
                        Bus Route:
                    </p>
                    <div
                        style="margin: 8px 0"
                        v-if="languageTypeVal == 2"
                        v-html="trafficRoute"
                    ></div>
                    <p style="font-size: 14px" v-if="languageTypeVal == 3">
                        སྤྱི་སྤྱོད་རླངས་འཁོར་གྱི་ལམ་ཐིག:
                    </p>
                    <div
                        style="margin: 8px 0"
                        v-if="languageTypeVal == 3"
                        v-html="trafficRoute"
                    ></div>
                    <p style="font-size: 14px">
                        <font v-if="languageTypeVal == 3"
                            >འབྲེལ་གཏུག་ཁ་པར། :</font
                        >
                        <font v-if="languageTypeVal == 2"
                            >Contact Number：</font
                        >
                    </p>
                    <p style="font-size: 12px; margin: 8px 0; color: #ccc">
                        0891-6835244 &nbsp;&nbsp;&nbsp;&nbsp; 0891-6812210
                    </p>
                </div>
                <div
                    class="footer_box_rt"
                    v-show="languageTypeVal == 2 || languageTypeVal == 3"
                >
                    <select v-model="selected" @change="getUrl">
                        <option value style="display: none">
                            <font v-if="languageTypeVal == 3"
                                >ཕུན་ཚོགས་མཛའ་འབྲེལ།</font
                            >
                            <font v-if="languageTypeVal == 2">links</font>
                        </option>
                        <option value="http://www.ncha.gov.cn/"
                            >国家文物局</option
                        >
                        <option value="https://www.dpm.org.cn/Home.html"
                            >故宫博物院</option
                        >
                        <option value="http://www.chnmuseum.cn/"
                            >国家博物馆</option
                        >
                        <option value="http://www.capitalmuseum.org.cn/"
                            >首都博物馆</option
                        >
                        <option value="https://www.shanghaimuseum.net/"
                            >上海博物馆</option
                        >
                        <option
                            value="http://www.njmuseum.com/html/default.html"
                        >
                            南京博物院
                        </option>
                        <option value="http://www.gdmuseum.com/"
                            >广东博物院</option
                        >
                        <option value="http://www.ynmuseum.org/index.html">
                            云南博物馆
                        </option>
                        <option value="http://www.hnmuseum.com/"
                            >湖南博物馆</option
                        >
                        <option value="http://www.sxhm.com/"
                            >陕西历史博物馆</option
                        >
                        <option value="http://www.scmuseum.cn/"
                            >四川省博物院</option
                        >
                    </select>
                </div>
                <div class="footer_box_rt" v-show="languageTypeVal == 1">
                    <select v-model="selected" @change="getUrl">
                        <option value style="display: none">友情链接</option>
                        <option value="http://www.ncha.gov.cn/"
                            >国家文物局</option
                        >
                        <option value="https://www.dpm.org.cn/Home.html"
                            >故宫博物院</option
                        >
                        <option value="http://www.chnmuseum.cn/"
                            >国家博物馆</option
                        >
                        <option value="http://www.capitalmuseum.org.cn/"
                            >首都博物馆</option
                        >
                        <option value="https://www.shanghaimuseum.net/"
                            >上海博物馆</option
                        >
                        <option
                            value="http://www.njmuseum.com/html/default.html"
                        >
                            南京博物院
                        </option>
                        <option value="http://www.gdmuseum.com/"
                            >广东博物院</option
                        >
                        <option value="http://www.ynmuseum.org/index.html">
                            云南博物馆
                        </option>
                        <option value="http://www.hnmuseum.com/"
                            >湖南博物馆</option
                        >
                        <option value="http://www.sxhm.com/"
                            >陕西历史博物馆</option
                        >
                        <option value="http://www.scmuseum.cn/"
                            >四川省博物院</option
                        >
                    </select>
                    <p style="font-size: 14px">博物馆地址:</p>
                    <p style="font-size: 12px; margin: 8px 0; color: #ccc">
                        西藏自治区拉萨市城关区民族南路2号
                    </p>
                    <p style="font-size: 14px">联系电话：</p>
                    <p style="font-size: 12px; margin: 8px 0; color: #ccc">
                        0891-6835244 0891-6812210
                    </p>
                </div>
                <div style="clear: both"></div>
            </div>
            <div
                class="visit_num"
                v-show="languageTypeVal == 1"
                style="margin-top: 30px"
            >
                网站访问人数 ： {{ visitCount }}
            </div>
            <div
                class="visit_num"
                v-show="languageTypeVal == 2"
                style="margin-top: 40px"
            >
                Number of Website Visitors ： {{ visitCount }}
            </div>
            <div
                class="visit_num"
                v-show="languageTypeVal == 3"
                style="margin-top: 40px"
            >
                དྲ་ཚིགས་བཀླགས་པའི་མི་གྲངས། ： {{ visitCount }}
            </div>
            <div class="footer_btm" v-show="languageTypeVal == 1">
                <span>©2018 西藏博物馆 &nbsp;&nbsp;</span>
                <a style="margin: 0 60px" href="https://beian.miit.gov.cn"
                    >备案：藏ICP备18000397号-1</a
                >
                <!-- <span>技术支持：天津恒达文博科技股份有限公司</span> -->
            </div>
            <div class="footer_btm" v-show="languageTypeVal == 2">
                <span>©2018 Tibet Museum&nbsp;&nbsp;</span>
                <a style="margin: 0 60px" href="https://beian.miit.gov.cn"
                    >Tibetan ICP No.18000397-1</a
                >
                <!-- <span>Technical Support: Tianjin Hengda Wenbo S&T Co., Ltd.</span> -->
            </div>
            <div class="footer_btm" v-show="languageTypeVal == 3">
                <span>©2018 བོད་ལྗོངས་རྟེན་རྫས་བཤམས་མཛོད་ཁང་།&nbsp;&nbsp;</span>
                <a style="margin: 0 60px" href="https://beian.miit.gov.cn"
                    >བོད་ICPཉར་ཨང་18000397པ།-1</a
                >
                <!-- <span>ལག་རྩལ་རྒྱབ་སྐྱོར། ཐེན་ཅིན་ཧུན་ཏའི་ཝུན་པའོ་ཚན་རྩལ་མ་རྐང་ཚད་ཡོད་ཀུང་སི།</span> -->
            </div>
            <!-- <div>{{ storeVal }}</div> -->
        </footer>
    </div>
</template>

<script>
/** @format */
import { Local, goSso, createIframeHandleToken } from "../lib/utils";
import { incrwebsit, museumBrief, getMemberIsOpen } from "../ports/getData.js";
import store from "../store/store";

export default {
    data() {
        return {
            selected: "",
            keyword: "",
            isShowSearchBox: false,
            branchNavIsHide: true,
            languageTypeVal: 1,
            navIndex: 0, //0~7分别代表导航的首页...
            visitCount: 0,
            trafficRoute: "",
            isShowSearchBox2: false,
            keyWord2: "",
            // 0关闭 1开启
            isOpen: 0,
            Local
        };
    },
    async created() {
        //统一用户和票务系统的域名
        // await this.$store.dispatch('domainInfo')
        // createIframeHandleToken('GET',this.$store.state.ssoLoginJumpUrl)
    },

    beforeMount() {
        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
            window.location.href = location.origin + "/m/?time=" + Date.now();
            //手机端
        }
    },
    mounted() {
        const v = this;
        v.getincrwebsit();
        var winh = document.documentElement.clientHeight;
        document.getElementsByClassName("main")[0].style.minHeight =
            winh - 492 + "px";
        if (localStorage.language == "undefined") {
            localStorage.language = "1";
            localStorage.languageType = "zh-CN";
        } else {
            this.languageTypeVal = localStorage.language;
        }
        this.MemberIsOpen();
    },
    computed: {
        storeVal: function() {
            return this.$store.state.isKeep;
        }
    },
    watch: {
        $route(to, from) {
            this.navIndex = to.query.navIndex;
            if (to.path.slice(0, 6) == "/zh-CN") {
                document.title = "西藏博物馆";
                localStorage.languageType = "zh-CN";
                localStorage.language = "1";
                this.languageTypeVal = 1;
            } else if (to.path.slice(0, 6) == "/en-US") {
                document.title = "Tibet Museum";
                this.getmuseumBrief();
                localStorage.languageType = "en-US";
                localStorage.language = "2";
                this.languageTypeVal = 2;
            } else if (to.path.slice(0, 6) == "/zangs") {
                document.title = "བོད་ལྗོངས་རྟེན་རྫས་བཤམས་མཛོད་ཁང་།";
                this.getmuseumBrief();
                localStorage.languageType = "zangs";
                localStorage.language = "3";
                this.languageTypeVal = 3;
            }
        },
        "$store.state.token"(val) {
            console.log("token:" + val);
        }
    },
    methods: {
        // 判断是否打开博物馆会员跳转按钮
        MemberIsOpen() {
            getMemberIsOpen().then(res => {
                if (res.data.status == 1) {
                    this.isOpen = +res.data.data.is_open;
                }
            });
        },
        userLogOut() {
            // const returnUrl = window.location.href
            // const ssoLoginJumpUrl = this.$store.state.ssoLoginJumpUrl
            // const inOrOut = 1 //1退出 0 登录
            // Local.remove('token')
            // Local.remove('isPersonal')
            // goSso(returnUrl,ssoLoginJumpUrl,inOrOut)
            createIframeHandleToken("REM", this.$store.state.ssoLoginJumpUrl);
        },
        getincrwebsit() {
            incrwebsit().then(res => {
                if (res.data && res.data.data) {
                    this.visitCount = res.data.data.count;
                }
            });
        },
        getmuseumBrief() {
            const v = this;
            museumBrief(parseInt(2)).then(res => {
                v.trafficRoute = res.data.data;
            });
        },
        getUrl() {
            if (this.selected != "") {
                window.open(this.selected);
                this.selected = "";
            }
        },
        open3(val) {
            this.$message({
                message: val,
                type: "warning"
            });
        },
        search(val, val1) {
            if (this.keyWord2 == "") {
                this.open3(val1);
            } else {
                this.isShowSearchBox2 = false;
                this.$router.push({
                    path: "/" + val + "/searchResult",
                    query: {
                        keyword: this.keyWord2,
                        random: Math.random()
                    }
                });
            }
        },
        tabLanguage(languageVal) {
            const v = this;
            v.keyword = "";
            v.languageTypeVal = languageVal;
            localStorage.language = languageVal;
            if (languageVal == 1) {
                localStorage.languageType = "zh-CN";
                v.$router.push({
                    path: "/zh-CN/index",
                    query: {
                        navIndex: 0
                    }
                });
            } else if (languageVal == 2) {
                localStorage.languageType = v.$route.query.navValnguageType =
                    "en-US";
                v.$router.push({
                    path: "/en-US/index",
                    query: {
                        navIndex: 0
                    }
                });
            } else if (languageVal == 3) {
                localStorage.languageType = v.$route.query.navValnguageType =
                    "zangs";
                v.$router.push({
                    path: "/zangs/index",
                    query: {
                        navIndex: 0
                    }
                });
            }
        },
        logoJump() {
            let toUrl = "/" + localStorage.languageType + "/index";
            this.$router.push({
                path: toUrl,
                query: {
                    navIndex: 0
                }
            });
        },
        tabNav(val, val1, type) {
            if (arguments.length === 0) return;
            if (val1 == "jianshezhong") {
                this.$message({
                    type: "warning",
                    message: "正在建设中"
                });
                return;
            }

            if (
                (val == "博物馆之友" || val == "博物馆会员") &&
                type == "jump"
            ) {
                console.log(val1);
                const storeState = this.$store.state;
                let token = storeState.token;
                window.open(
                    `${val1}?token=${token}&userId=${
                        storeState.userId
                    }&isPersonal=${this.$store.state.isPersonal ? 1 : 2}`
                );
                return;
            }

            if (val == "票务预约") {
                if (!val1) return;
                this.navIndex = val;
                const storeState = this.$store.state;
                if (storeState.token) {
                    if (type === "person" && !storeState.isPersonal) {
                        this.$message.warning(
                            "暂不支持团队预约，如需预约，请使用个人账户登录"
                        );
                    } else {
                        window.open(
                            `${val1}?token=${storeState.token}&userId=${
                                storeState.userId
                            }&isPersonal=${
                                this.$store.state.isPersonal ? 1 : 2
                            }&lang=zh-CN`
                        );
                    }
                } else {
                    // 创建统一登录ifarm获取token
                    createIframeHandleToken(
                        "GET",
                        storeState.ssoLoginJumpUrl,
                        () => {
                            let token = storeState.token;
                            if (token) {
                                if (
                                    type === "person" &&
                                    !storeState.isPersonal
                                ) {
                                    this.$message.warning(
                                        "暂不支持团队预约，如需预约，请使用个人账户登录"
                                    );
                                } else {
                                    window.open(
                                        `${val1}?token=${token}&userId=${
                                            storeState.userId
                                        }&isPersonal=${
                                            this.$store.state.isPersonal ? 1 : 2
                                        }&lang=zh-CN`
                                    );
                                }
                            } else {
                                window.open(`${val1}?lang=zh-CN`);
                            }
                        }
                    );
                }
            } else {
                this.$router.push({
                    path: val1,
                    query: {
                        navIndex: val
                    }
                });
            }
        },
        tabNavUC(val, val1, type) {
            if (arguments.length === 0) return;
            if (val1 == "jianshezhong") {
                this.$message({
                    type: "warning",
                    message: "正在建设中"
                });
                return;
            }

            if (
                (val == "博物馆之友" || val == "博物馆会员") &&
                type == "jump"
            ) {
                console.log(val1);
                const storeState = this.$store.state;
                let token = storeState.token;
                window.open(
                    `${val1}?token=${token}&userId=${
                        storeState.userId
                    }&isPersonal=${this.$store.state.isPersonal ? 1 : 2}`
                );
                return;
            }

            if (val == "票务预约") {
                if (!val1) return;
                this.navIndex = val;
                const storeState = this.$store.state;
                if (storeState.token) {
                    if (type === "person" && !storeState.isPersonal) {
                        this.$message.warning(
                            "暂不支持团队预约，如需预约，请使用个人账户登录"
                        );
                    } else {
                        let url = `${val1}?token=${storeState.token}&userId=${
                            storeState.userId
                        }&isPersonal=${
                            this.$store.state.isPersonal ? 1 : 2
                        }&lang=en-US`;
                        window.open(
                            `${val1}?token=${storeState.token}&userId=${
                                storeState.userId
                            }&isPersonal=${
                                this.$store.state.isPersonal ? 1 : 2
                            }&lang=en-US`
                        );
                    }
                } else {
                    // 创建统一登录ifarm获取token
                    createIframeHandleToken(
                        "GET",
                        storeState.ssoLoginJumpUrl,
                        () => {
                            let token = storeState.token;
                            if (token) {
                                if (
                                    type === "person" &&
                                    !storeState.isPersonal
                                ) {
                                    this.$message.warning(
                                        "暂不支持团队预约，如需预约，请使用个人账户登录"
                                    );
                                } else {
                                    window.open(
                                        `${val1}?token=${token}&userId=${
                                            storeState.userId
                                        }&isPersonal=${
                                            this.$store.state.isPersonal ? 1 : 2
                                        }&lang=en-US`
                                    );
                                }
                            } else {
                                window.open(`${val1}?lang=en-US`);
                            }
                        }
                    );
                }
            } else {
                this.$router.push({
                    path: val1,
                    query: {
                        navIndex: val
                    }
                });
            }
        }
    }
};
</script>

<style scoped lang="scss">
.el-dropdown {
    float: left;
    border-left: 1px solid #fff;
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #fff;
    color: #f0a941;
}
/**
 * /*搜索弹窗
 *
 * @format
 */
.boss-contanier {
    background: url("../images/new/-m-beijing.png");
}
.search_box {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: url(../images/search.jpg);
    background-size: auto;
    z-index: 999;
    .close_search_box {
        width: 32px;
        height: 32px;
        position: absolute;
        top: 12.3%;
        right: 10.4%;
        cursor: pointer;
    }
    .search_main {
        width: 80%;
        height: 24px;
        padding: 10px 20px;
        border-bottom: 1px solid #edaa42;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        /* IE 9 */
        -webkit-transform: translate(-50%, -50%);
        /* Safari and Chrome */
        -o-transform: translate(-50%, -50%);
        /* Opera */
        -moz-transform: translate(-50%, -50%);
        span {
            display: block;
            float: left;
            width: 26px;
            height: 26px;
            background: url(../images//search_icon_y.png) no-repeat;
            float: left;
        }
        input[type="button"] {
            float: right;
            font-size: 24px;
            height: 30px;
            line-height: 30px;
            color: #edaa42;
            border: 0;
            background: rgba(0, 0, 0, 0);
            cursor: pointer;
            outline: none;
        }
        input[type="text"] {
            font-size: 24px;
            color: #fff;
            height: 24px;
            line-height: 24px;
            width: 60%;
            text-align: center;
            margin: 0 auto;
            border: 0;
            background: rgba(0, 0, 0, 0);
            outline: none;
            margin-left: 20%;
        }
    }
}
/*公共头部*/

header {
    background: #002746;
    .branch_nav {
        width: 100%;
        height: 50px;
        background: rgba(0, 0, 0, 0.6);
        position: absolute;
        top: 100px;
        left: 0;
        z-index: 998;
    }
    .is_hide {
        display: none;
    }
    .header_box {
        width: 1400px;
        height: 100px;
        margin: 0 auto;
        .logo_box {
            overflow: hidden;
            float: left;
            cursor: pointer;
            img {
                display: block;
                margin-top: 16px;
            }
        }
        .header_right_box {
            float: right;
            .tools_box {
                overflow: hidden;
                margin-top: 20px;
                font-size: 14px;
                color: #fff;
                span {
                    cursor: pointer;
                    display: block;
                    float: right;
                    height: 14px;
                    line-height: 14px;
                    padding: 0 10px;
                    border-right: 1px solid #fff;
                    &.selected_lanuage {
                        color: #f0a941;
                    }
                    &.search {
                        width: 15px;
                        height: 14px;
                        background: url(../images/pc_sousuo.png) no-repeat top
                            center;
                    }
                    &.user {
                        width: 14px;
                        height: 14px;
                        background: url(../images/pc_user.png) no-repeat top
                            center;
                        position: relative;
                    }
                    &.user-logout {
                        position: absolute;
                        top: -18px;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 82px;
                        height: 36px;
                        border: 1px solid #ebeef5;
                        color: #000;
                        border-radius: 4px;
                        background: #fff;
                        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                    }
                    &.userActive {
                        background: url(../images/pc_user_active.png) no-repeat
                            top center;
                    }
                }
            }
            .navs_box {
                margin-top: 14px;
                position: relative;
                height: 52px;
                ul {
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    width: 1180px;
                    height: 52px;
                    li {
                        cursor: pointer;
                        float: left;
                        color: #fff;
                        font-size: 16px;
                        margin-left: 43px;
                        height: 50px;
                        line-height: 50px;
                        position: relative;
                        &:hover {
                            color: #edaa42;
                        }
                        &:hover .branch_titles {
                            display: block;
                        }
                        &:hover .branch_titles_right {
                            display: block;
                        }
                        &.selected_nav {
                            color: #edaa42;
                            border-bottom: 2px solid #edaa42;
                        }
                        .branch_titles {
                            display: none;
                            z-index: 999;
                            position: absolute;
                            top: 50px;
                            left: 50%;
                            font-size: 14px;
                            color: #fff;
                            height: 50px;
                            transform: translate(-50%, 0);
                            -ms-transform: translate(-50%, 0);
                            /* IE 9 */
                            -webkit-transform: translate(-50%, 0);
                            /* Safari and Chrome */
                            -o-transform: translate(-50%, 0);
                            /* Opera */
                            -moz-transform: translate(-50%, 0);
                            span {
                                display: inline-block;
                                height: 14px;
                                line-height: 14px;
                                border-right: 1px solid #fff;
                                margin-top: 18px;
                                padding: 0 10px;
                                &:last-child {
                                    border: 0;
                                }
                                &:hover {
                                    color: #edaa42;
                                }
                            }
                        }
                        .branch_titles2 {
                            transform: translate(-80%, 0) !important;
                        }
                        .branch_titles_right {
                            display: none;
                            z-index: 999;
                            position: absolute;
                            top: 50px;
                            right: -10px;
                            font-size: 14px;
                            color: #fff;
                            height: 50px;
                            span {
                                display: inline-block;
                                height: 14px;
                                line-height: 14px;
                                border-right: 1px solid #fff;
                                margin-top: 18px;
                                padding: 0 10px;
                                &:last-child {
                                    border: 0;
                                }
                                &:hover {
                                    color: #edaa42;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

.us_header {
    li {
        margin-left: 47px !important;
    }
}
/*公共底部*/

footer {
    background: #002746;
    overflow: hidden;
    position: relative;
    &::after {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-image: url(../images/home_bg.png);
        background-size: 100% auto;
        background-repeat: no-repeat;
        opacity: 0.6;
        pointer-events: none;
    }
    .visit_num {
        color: #eea943;
        font-size: 18px;
        text-align: center;
        margin-bottom: 20px;
        margin-top: 10px;
    }
    .footer_btm,
    .footer_btm a {
        height: 75px;
        text-align: center;
        color: #d4d4d4;
        font-size: 14px;
        line-height: 75px;
    }
    .footer_btm {
        border-top: 1px solid #426c8e;
    }
    .footer_box {
        position: relative;
        width: 1200px;
        min-height: 180px;
        margin: 0 auto;
        margin-top: 30px;
        .museum_info {
            p {
                color: #fff;
            }
        }
        .footer_box_rt {
            width: 214px;
            float: right;
            select {
                width: 214px;
                height: 30px;
                background: #002746;
                color: #fff;
                margin-bottom: 50px;
            }
            p {
                color: #fff;
            }
        }
        table {
            border-collapse: collapse;
            width: 920px;
            border: 0;
            float: left;
            tr {
                th {
                    font-size: 16px;
                    color: #fff;
                    text-align: left;
                    padding-bottom: 20px;
                    cursor: pointer;
                    &:hover {
                        color: #eea943;
                    }
                }
                td {
                    font-size: 14px;
                    color: #fff;
                    height: 30px;
                    cursor: pointer;
                    &:hover {
                        color: #eea943;
                    }
                }
            }
        }
    }
}
.search-box2-wrap {
    position: relative;
    .s-box2-div {
        display: inline-block;
        position: absolute;
        z-index: 100;
        transform: translateY(5px);

        .sousuo {
            content: "";
            position: absolute;
            right: 16px;
            top: 16px;
            width: 18px;
            height: 18px;
            background: url("../images/new/sousuo.png") no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
        }
        .search-box2 {
            width: 276px;
            height: 48px;
            background: #ffffff;
            border-radius: 4px;
            outline: none;
            border: none;
            box-sizing: border-box;
            padding: 10px;
            padding-right: 40px;
            border: 1px solid rgb(209, 209, 209);
            border-radius: 6px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/app.vue